import gql from 'graphql-tag';
import fragments from '../fragments';

export default {
    createCampaignMutation: gql`
        mutation CreateCampaign($name: String!, $termsText: String, $privacyText: String, $promptText: String!, $isNPSCampaign: Boolean!, $NPSQuestion: String, $isCSATCampaign: Boolean!, $CSATQuestion: String, $interfaceLanguage: String) {
            createCampaign(campaign: { name: $name, termsText: $termsText, privacyText: $privacyText, promptText: $promptText, isNPSCampaign: $isNPSCampaign, NPSQuestion: $NPSQuestion, isCSATCampaign: $isCSATCampaign, CSATQuestion: $CSATQuestion, interfaceLanguage: $interfaceLanguage }) {
                ...CampaignFragment
            }
        }

        ${fragments.campaign}
        ${fragments.image}
        ${fragments.tag}
    `,
};
